module.exports = __webpack_public_path__ + "43cd86c9128fd849d4cbdcc1eb263650.png";